import React from 'react';
import {Row, Col} from 'antd';
import asset1 from '../../Assests/assets/images/asset-1.svg';
import CourseTitleInfo from '../CourseTitleInfo/CourseTitleInfo';
import Overview from '../Overview/Overview';
import Learn from '../Learn/Learn';
import Myths from '../Myths/Myths';
import Investment from '../Investment/Investment';
import Benefiter from '../Benefiter/Benefiter';
import CourseStructure from '../CourseStructure/CourseStructure';
import Pricing from '../Pricing/Pricing';
import PageHeader from '../CourseHeader/Header';

const MainContent = (props) => {
  return (
    <>
      <span class='main-title'>
      <PageHeader/>
      <Row className="mai-title">
        <Col xs={24} md={24} lg={15} xl={13} className='main-title-left'>
          <CourseTitleInfo isLoggedIn={props.isLoggedIn}/>
        </Col>
        <Col xs={24} md={24} lg={9} xl={11}>
          <span class='main-title-right-img-container'>
            <img class='main-title-right-img' src={asset1}/>
          </span>
        </Col>
      </Row>
      </span>
      <span id='course-about-overview-gutter'></span>
      <Overview/>
      <span id='learn-overview-gutter'></span>
      <Learn/>
      <span id="myths-learn-gutter"></span>
      <Myths/>
      <span id="investment-myths-gutter"></span>
      <Investment isLoggedIn={props.isLoggedIn}/>
      <span id="benefiter-investment-gutter"></span>
      <Benefiter />
      <span id='structure-benefiter-gutter'></span>
      <CourseStructure isLoggedIn={props.isLoggedIn}/>
      <span id='pricing-structure-gutter'></span>
      <Pricing isLoggedIn={props.isLoggedIn}/>
    </>
  )
}
export default MainContent;
